"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var index_native_exports = {};
__export(index_native_exports, {
  Database: () => Database
});
module.exports = __toCommonJS(index_native_exports);
var import_op_sqlite = require("@op-engineering/op-sqlite");
var import_keyValue = require("./keyValue.native");
var Database = Object.freeze({
  open: import_op_sqlite.open,
  openAsync: import_op_sqlite.openAsync,
  openKeyValue: import_keyValue.openKeyValue
});
//# sourceMappingURL=index.native.js.map
